import React from "react";
import { Navigate } from "react-router-dom";
import BasicSignIn from '../pages/AuthenticationInner/Login/BasicSignIn';
import CoverSignIn from '../pages/AuthenticationInner/Login/CoverSignIn';
import BasicSignUp from '../pages/AuthenticationInner/Register/BasicSignUp';
import CoverSignUp from "../pages/AuthenticationInner/Register/CoverSignUp";
import BasicPasswReset from '../pages/AuthenticationInner/PasswordReset/BasicPasswReset';
import Maintenance from '../pages/Pages/Maintenance/Maintenance';
import ComingSoon from '../pages/Pages/ComingSoon/ComingSoon';
import CoverPasswReset from '../pages/AuthenticationInner/PasswordReset/CoverPasswReset';
import BasicLockScreen from '../pages/AuthenticationInner/LockScreen/BasicLockScr';
import CoverLockScreen from '../pages/AuthenticationInner/LockScreen/CoverLockScr';
import BasicLogout from "pages/AuthenticationInner/Logout/BasicLogout";
import CoverLogout from '../pages/AuthenticationInner/Logout/CoverLogout';
import BasicSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg';
import CoverSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg';
import BasicTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify';
import CoverTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify';
import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';
import Cover404 from '../pages/AuthenticationInner/Errors/Cover404';
import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import Error500 from '../pages/AuthenticationInner/Errors/Error500';
import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";
import CoverPasswCreate from "../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";
import Login from "../pages/Authentication/Login";
import ForgotPassword from "../pages/Authentication/ForgotPassword";
import ResetPassword from "../pages/Authentication/ResetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import GoogleCallback from "../pages/Authentication/GoogleCallback";
import CoderomLanding from "../pages/Landing/Coderom";
import PricingPage from "../pages/Landing/Coderom/PricingPage";
import FAQPage from "../pages/Landing/Coderom/FAQ";
import HelpCenter from "../pages/Landing/Coderom/HelpCenter";
import HelpArticleGettingStarted from "../pages/Landing/Coderom/HelpArticleGettingStarted";
import HelpArticleAiListing from "../pages/Landing/Coderom/HelpArticleAiListing";
import HelpArticleBulkImport from "../pages/Landing/Coderom/HelpArticleBulkImport";
import HelpArticleTemplates from "../pages/Landing/Coderom/HelpArticleTemplates";
import HelpArticlePricing from "../pages/Landing/Coderom/HelpArticlePricing";
import HelpArticleSafeRepricing from "../pages/Landing/Coderom/HelpArticleSafeRepricing";
import HelpArticleStock from "../pages/Landing/Coderom/HelpArticleStock";
import HelpArticleAmazonFilters from "../pages/Landing/Coderom/HelpArticleAmazonFilters";
import HelpArticleOrders from "../pages/Landing/Coderom/HelpArticleOrders";
import HelpArticleSafetyProtection from "../pages/Landing/Coderom/HelpArticleSafetyProtection";
import HelpArticleAutoMessages from "../pages/Landing/Coderom/HelpArticleAutoMessages";
import HelpArticleGmailTracking from "../pages/Landing/Coderom/HelpArticleGmailTracking";
import HelpArticleEbayMultistore from "../pages/Landing/Coderom/HelpArticleEbayMultistore";
import HelpArticleReports from "../pages/Landing/Coderom/HelpArticleReports";
import HelpArticleAccountBilling from "../pages/Landing/Coderom/HelpArticleAccountBilling";
import HelpArticleMigration from "../pages/Landing/Coderom/HelpArticleMigration";
import BlogPage from "../pages/Landing/Coderom/Blog";
import BlogPostDetail from "../pages/Landing/Coderom/BlogPostDetail";
import CommunityPage from "../pages/Landing/Coderom/Community";
import CoderomPrivacyPolicy from '../pages/Landing/Coderom/PrivacyPolicy';
import CoderomTermsOfService from '../pages/Landing/Coderom/TermsOfService';
import CoderomCookiePolicy from '../pages/Landing/Coderom/CookiePolicy';
import CoderomGDPRPolicy from '../pages/Landing/Coderom/GDPRPolicy';
import AboutUs from '../pages/Landing/Coderom/AboutUs';
import EbayFeeCalculator from "../pages/Landing/Coderom/Tools/EbayFeeCalculator";
import ProfitCalculator from "../pages/Landing/Coderom/Tools/ProfitCalculator";
import TitleOptimizer from "../pages/Landing/Coderom/Tools/TitleOptimizer";
import CompareAutoDS from "../pages/Landing/Coderom/Compare/CompareAutoDS";
import CompareEasync from "../pages/Landing/Coderom/Compare/CompareEasync";
import CompareYaballe from "../pages/Landing/Coderom/Compare/CompareYaballe";

// --- Lazy-loaded protected routes ---
const Setup = React.lazy(() => import("../pages/Setup"));
const DashboardAnalytics = React.lazy(() => import("../pages/DashboardAnalytics"));
const DashboardCrm = React.lazy(() => import("../pages/DashboardCrm"));
const DashboardEcommerce = React.lazy(() => import("../pages/DashboardEcommerce"));
const DashboardCrypto = React.lazy(() => import("../pages/DashboardCrypto"));
const DashboardProject = React.lazy(() => import("../pages/DashboardProject"));
const DashboardNFT = React.lazy(() => import("../pages/DashboardNFT"));
const DashboardJob = React.lazy(() => import("../pages/DashboardJob"));
const DashboardBlog = React.lazy(() => import("../pages/DashboardBlog"));
const MailInbox = React.lazy(() => import("../pages/EmailInbox"));
const BasicAction = React.lazy(() => import("../pages/Email/EmailTemplates/BasicAction"));
const EcommerceAction = React.lazy(() => import("../pages/Email/EmailTemplates/EcommerceAction"));
const Chat = React.lazy(() => import("../pages/Chat"));
const Calendar = React.lazy(() => import("../pages/Calendar"));
const MonthGrid = React.lazy(() => import("../pages/Calendar/monthGrid"));
const ProjectList = React.lazy(() => import("../pages/Projects/ProjectList"));
const ProjectOverview = React.lazy(() => import("../pages/Projects/ProjectOverview"));
const CreateProject = React.lazy(() => import("../pages/Projects/CreateProject"));
const TaskDetails = React.lazy(() => import("../pages/Tasks/TaskDetails"));
const TaskList = React.lazy(() => import("../pages/Tasks/TaskList"));
const Transactions = React.lazy(() => import("../pages/Crypto/Transactions"));
const BuySell = React.lazy(() => import("../pages/Crypto/BuySell"));
const CryproOrder = React.lazy(() => import("../pages/Crypto/CryptoOrder"));
const MyWallet = React.lazy(() => import("../pages/Crypto/MyWallet"));
const ICOList = React.lazy(() => import("../pages/Crypto/ICOList"));
const KYCVerification = React.lazy(() => import("../pages/Crypto/KYCVerification"));
const InvoiceList = React.lazy(() => import("../pages/Invoices/InvoiceList"));
const InvoiceCreate = React.lazy(() => import("../pages/Invoices/InvoiceCreate"));
const InvoiceDetails = React.lazy(() => import("../pages/Invoices/InvoiceDetails"));
const ListView = React.lazy(() => import("../pages/SupportTickets/ListView"));
const TicketsDetails = React.lazy(() => import("../pages/SupportTickets/TicketsDetails"));
const UserTickets = React.lazy(() => import("../pages/SupportTickets/UserTickets"));
const TicketDetail = React.lazy(() => import("../pages/SupportTickets/TicketDetail"));
const AdminTicketManagement = React.lazy(() => import("../pages/Admin/TicketManagement"));
const AdminTicketDetail = React.lazy(() => import("../pages/Admin/TicketManagement/TicketDetail"));
const EcommerceProducts = React.lazy(() => import("../pages/Ecommerce/EcommerceProducts/index-new"));
const EcommerceProductDetail = React.lazy(() => import("../pages/Ecommerce/EcommerceProducts/ProductDetail"));
const EcommerceAddProduct = React.lazy(() => import("../pages/Ecommerce/EcommerceProducts/EcommerceAddProduct-new"));
const EcommerceOrders = React.lazy(() => import("../pages/Ecommerce/EcommerceOrders/index-new"));
const EcommerceOrderDetail = React.lazy(() => import("../pages/Ecommerce/EcommerceOrders/EcommerceOrderDetail-new"));
const EcommerceCustomers = React.lazy(() => import("../pages/Ecommerce/EcommerceCustomers/index"));
const EcommerceCart = React.lazy(() => import("../pages/Ecommerce/EcommerceCart"));
const EcommerceCheckout = React.lazy(() => import("../pages/Ecommerce/EcommerceCheckout"));
const EcommerceSellers = React.lazy(() => import("../pages/Ecommerce/EcommerceSellers/index"));
const EcommerceSellerDetail = React.lazy(() => import("../pages/Ecommerce/EcommerceSellers/EcommerceSellerDetail"));
const EcommerceDrafts = React.lazy(() => import("../pages/Ecommerce/EcommerceDrafts"));
const EditDraft = React.lazy(() => import("../pages/Ecommerce/EcommerceDrafts/EditDraft"));
const PublishSuccess = React.lazy(() => import("../pages/Ecommerce/PublishSuccess"));
const Marketplace = React.lazy(() => import("../pages/NFTMarketplace/Marketplace"));
const Collections = React.lazy(() => import("../pages/NFTMarketplace/Collections"));
const CreateNFT = React.lazy(() => import("../pages/NFTMarketplace/CreateNFT"));
const Creators = React.lazy(() => import("../pages/NFTMarketplace/Creators"));
const ExploreNow = React.lazy(() => import("../pages/NFTMarketplace/ExploreNow"));
const ItemDetails = React.lazy(() => import("../pages/NFTMarketplace/Itemdetails"));
const LiveAuction = React.lazy(() => import("../pages/NFTMarketplace/LiveAuction"));
const Ranking = React.lazy(() => import("../pages/NFTMarketplace/Ranking"));
const WalletConnect = React.lazy(() => import("../pages/NFTMarketplace/WalletConnect"));
const UiAlerts = React.lazy(() => import("../pages/BaseUi/UiAlerts/UiAlerts"));
const UiBadges = React.lazy(() => import("../pages/BaseUi/UiBadges/UiBadges"));
const UiButtons = React.lazy(() => import("../pages/BaseUi/UiButtons/UiButtons"));
const UiColors = React.lazy(() => import("../pages/BaseUi/UiColors/UiColors"));
const UiCards = React.lazy(() => import("../pages/BaseUi/UiCards/UiCards"));
const UiCarousel = React.lazy(() => import("../pages/BaseUi/UiCarousel/UiCarousel"));
const UiDropdowns = React.lazy(() => import("../pages/BaseUi/UiDropdowns/UiDropdowns"));
const UiGrid = React.lazy(() => import("../pages/BaseUi/UiGrid/UiGrid"));
const UiImages = React.lazy(() => import("../pages/BaseUi/UiImages/UiImages"));
const UiTabs = React.lazy(() => import("../pages/BaseUi/UiTabs/UiTabs"));
const UiAccordions = React.lazy(() => import("../pages/BaseUi/UiAccordion&Collapse/UiAccordion&Collapse"));
const UiModals = React.lazy(() => import("../pages/BaseUi/UiModals/UiModals"));
const UiOffcanvas = React.lazy(() => import("../pages/BaseUi/UiOffcanvas/UiOffcanvas"));
const UiPlaceholders = React.lazy(() => import("../pages/BaseUi/UiPlaceholders/UiPlaceholders"));
const UiProgress = React.lazy(() => import("../pages/BaseUi/UiProgress/UiProgress"));
const UiNotifications = React.lazy(() => import("../pages/BaseUi/UiNotifications/UiNotifications"));
const UiMediaobject = React.lazy(() => import("../pages/BaseUi/UiMediaobject/UiMediaobject"));
const UiEmbedVideo = React.lazy(() => import("../pages/BaseUi/UiEmbedVideo/UiEmbedVideo"));
const UiTypography = React.lazy(() => import("../pages/BaseUi/UiTypography/UiTypography"));
const UiList = React.lazy(() => import("../pages/BaseUi/UiLists/UiLists"));
const UiGeneral = React.lazy(() => import("../pages/BaseUi/UiGeneral/UiGeneral"));
const UiRibbons = React.lazy(() => import("../pages/BaseUi/UiRibbons/UiRibbons"));
const UiUtilities = React.lazy(() => import("../pages/BaseUi/UiUtilities/UiUtilities"));
const UiScrollbar = React.lazy(() => import("../pages/AdvanceUi/UiScrollbar/UiScrollbar"));
const UiAnimation = React.lazy(() => import("../pages/AdvanceUi/UiAnimation/UiAnimation"));
const UiSwiperSlider = React.lazy(() => import("../pages/AdvanceUi/UiSwiperSlider/UiSwiperSlider"));
const UiRatings = React.lazy(() => import("../pages/AdvanceUi/UiRatings/UiRatings"));
const UiHighlight = React.lazy(() => import("../pages/AdvanceUi/UiHighlight/UiHighlight"));
const Widgets = React.lazy(() => import("../pages/Widgets/Index"));
const BasicElements = React.lazy(() => import("../pages/Forms/BasicElements/BasicElements"));
const FormSelect = React.lazy(() => import("../pages/Forms/FormSelect/FormSelect"));
const FormEditor = React.lazy(() => import("../pages/Forms/FormEditor/FormEditor"));
const CheckBoxAndRadio = React.lazy(() => import("../pages/Forms/CheckboxAndRadio/CheckBoxAndRadio"));
const Masks = React.lazy(() => import("../pages/Forms/Masks/Masks"));
const FileUpload = React.lazy(() => import("../pages/Forms/FileUpload/FileUpload"));
const FormPickers = React.lazy(() => import("../pages/Forms/FormPickers/FormPickers"));
const FormRangeSlider = React.lazy(() => import("../pages/Forms/FormRangeSlider/FormRangeSlider"));
const Formlayouts = React.lazy(() => import("../pages/Forms/FormLayouts/Formlayouts"));
const FormValidation = React.lazy(() => import("../pages/Forms/FormValidation/FormValidation"));
const FormWizard = React.lazy(() => import("../pages/Forms/FormWizard/FormWizard"));
const FormAdvanced = React.lazy(() => import("../pages/Forms/FormAdvanced/FormAdvanced"));
const Select2 = React.lazy(() => import("../pages/Forms/Select2/Select2"));
const BasicTables = React.lazy(() => import("../pages/Tables/BasicTables/BasicTables"));
const ReactTable = React.lazy(() => import("../pages/Tables/ReactTables"));
const RemixIcons = React.lazy(() => import("../pages/Icons/RemixIcons/RemixIcons"));
const BoxIcons = React.lazy(() => import("../pages/Icons/BoxIcons/BoxIcons"));
const MaterialDesign = React.lazy(() => import("../pages/Icons/MaterialDesign/MaterialDesign"));
const FeatherIcons = React.lazy(() => import("../pages/Icons/FeatherIcons/FeatherIcons"));
const LineAwesomeIcons = React.lazy(() => import("../pages/Icons/LineAwesomeIcons/LineAwesomeIcons"));
const CryptoIcons = React.lazy(() => import("../pages/Icons/CryptoIcons/CryptoIcons"));
const GoogleMaps = React.lazy(() => import("../pages/Maps/GoogleMaps/GoogleMaps"));
const Starter = React.lazy(() => import("../pages/Pages/Starter/Starter"));
const SimplePage = React.lazy(() => import("../pages/Pages/Profile/SimplePage/SimplePage"));
const ProfileSettings = React.lazy(() => import("../pages/Pages/Profile/Settings/Settings"));
const Settings = React.lazy(() => import("../pages/Settings/index"));
const UserStoreManagement = React.lazy(() => import("../pages/Settings/StoreManagement"));
const EbayConnect = React.lazy(() => import("../pages/Integrations/EbayConnect"));
const EbayCallback = React.lazy(() => import("../pages/Integrations/EbayCallback"));
const SetupWizard = React.lazy(() => import("../pages/Setup/SetupWizard"));
const UserList = React.lazy(() => import("../pages/Admin/UserList"));
const UserDetail = React.lazy(() => import("../pages/Admin/UserDetail"));
const AdminDashboard = React.lazy(() => import("../pages/Admin/AdminDashboard"));
const AuditLogs = React.lazy(() => import("../pages/Admin/AuditLogs"));
const CreditManagement = React.lazy(() => import("../pages/Admin/CreditManagement"));
const InvoiceManagement = React.lazy(() => import("../pages/Admin/InvoiceManagement"));
const Notifications = React.lazy(() => import("../pages/Admin/Notifications"));
const PaymentManagement = React.lazy(() => import("../pages/Admin/PaymentManagement"));
const Reports = React.lazy(() => import("../pages/Admin/Reports"));
const StoreManagement = React.lazy(() => import("../pages/Admin/StoreManagement"));
const EbayAccountManagement = React.lazy(() => import("../pages/Admin/EbayAccountManagement"));
const SystemSettings = React.lazy(() => import("../pages/Admin/SystemSettings"));
const EmailSettings = React.lazy(() => import("../pages/Admin/EmailSettings"));
const SystemHealth = React.lazy(() => import("../pages/Admin/SystemHealth"));
const SubscriptionHealth = React.lazy(() => import("../pages/Admin/SubscriptionHealth"));
const OpsHealth = React.lazy(() => import("../pages/Admin/OpsHealth"));
const ScraperMonitoring = React.lazy(() => import("../pages/Admin/ScraperMonitoring"));
const DiscountCodes = React.lazy(() => import("../pages/Admin/DiscountCodes"));
const Team = React.lazy(() => import("../pages/Pages/Team/Team"));
const Timeline = React.lazy(() => import("../pages/Pages/Timeline/Timeline"));
const Faqs = React.lazy(() => import("../pages/Pages/Faqs/Faqs"));
const Pricing = React.lazy(() => import("../pages/Pages/Pricing/Pricing"));
const Subscription = React.lazy(() => import("../pages/Pages/Subscription"));
const Gallery = React.lazy(() => import("../pages/Pages/Gallery/Gallery"));
const SiteMap = React.lazy(() => import("../pages/Pages/SiteMap/SiteMap"));
const SearchResults = React.lazy(() => import("../pages/Pages/SearchResults/SearchResults"));
const APIKey = React.lazy(() => import("../pages/APIKey/index"));
const LineCharts = React.lazy(() => import("../pages/Charts/ApexCharts/LineCharts"));
const AreaCharts = React.lazy(() => import("../pages/Charts/ApexCharts/AreaCharts"));
const ColumnCharts = React.lazy(() => import("../pages/Charts/ApexCharts/ColumnCharts"));
const BarCharts = React.lazy(() => import("../pages/Charts/ApexCharts/BarCharts"));
const MixedCharts = React.lazy(() => import("../pages/Charts/ApexCharts/MixedCharts"));
const TimelineCharts = React.lazy(() => import("../pages/Charts/ApexCharts/TimelineCharts"));
const CandlestickChart = React.lazy(() => import("../pages/Charts/ApexCharts/CandlestickChart"));
const BoxplotCharts = React.lazy(() => import("../pages/Charts/ApexCharts/BoxplotCharts"));
const BubbleChart = React.lazy(() => import("../pages/Charts/ApexCharts/BubbleChart"));
const ScatterCharts = React.lazy(() => import("../pages/Charts/ApexCharts/ScatterCharts"));
const HeatmapCharts = React.lazy(() => import("../pages/Charts/ApexCharts/HeatmapCharts"));
const TreemapCharts = React.lazy(() => import("../pages/Charts/ApexCharts/TreemapCharts"));
const PieCharts = React.lazy(() => import("../pages/Charts/ApexCharts/PieCharts"));
const RadialbarCharts = React.lazy(() => import("../pages/Charts/ApexCharts/RadialbarCharts"));
const RadarCharts = React.lazy(() => import("../pages/Charts/ApexCharts/RadarCharts"));
const PolarCharts = React.lazy(() => import("../pages/Charts/ApexCharts/PolarCharts"));
const ChartsJs = React.lazy(() => import("../pages/Charts/ChartsJs/index"));
const Echarts = React.lazy(() => import("../pages/Charts/ECharts/index"));
const Statistics = React.lazy(() => import("../pages/Jobs/Statistics"));
const JobList = React.lazy(() => import("../pages/Jobs/JobList/List"));
const JobGrid = React.lazy(() => import("../pages/Jobs/JobList/Grid"));
const JobOverview = React.lazy(() => import("../pages/Jobs/JobList/Overview"));
const CandidateList = React.lazy(() => import("../pages/Jobs/CandidateList/ListView"));
const CandidateGrid = React.lazy(() => import("../pages/Jobs/CandidateList/GridView"));
const NewJobs = React.lazy(() => import("../pages/Jobs/NewJob"));
const JobCategories = React.lazy(() => import("../pages/Jobs/JobCategories"));
const Application = React.lazy(() => import("../pages/Jobs/Application"));
const CompaniesList = React.lazy(() => import("../pages/Jobs/CompaniesList"));
const PrivacyPolicy = React.lazy(() => import("../pages/Pages/PrivacyPolicy"));
const TermsCondition = React.lazy(() => import("../pages/Pages/TermsCondition"));
const UserProfile = React.lazy(() => import("../pages/Authentication/user-profile"));
const RangeArea = React.lazy(() => import("../pages/Charts/ApexCharts/RangeAreaCharts/Index"));
const FunnelChart = React.lazy(() => import("../pages/Charts/ApexCharts/FunnelCharts/Index"));
const FileManager = React.lazy(() => import("../pages/FileManager"));
const ToDoList = React.lazy(() => import("../pages/ToDo"));
const UiLink = React.lazy(() => import("../pages/BaseUi/UiLinks/UiLinks"));
const Kanbanboard = React.lazy(() => import("../pages/Tasks/KanbanBoard"));
const SlopeCharts = React.lazy(() => import("../pages/Charts/ApexCharts/SlopeCharts"));
const BlogListView = React.lazy(() => import("../pages/Pages/Blogs/ListView"));
const BlogGridView = React.lazy(() => import("../pages/Pages/Blogs/GridView"));
const PageBlogOverview = React.lazy(() => import("../pages/Pages/Blogs/Overview"));

const authProtectedRoutes = [

  // Setup/Onboarding
  { path: "/setup", component: <Setup /> },

  // dashboard
  { path: "/dashboard-analytics", component: <DashboardAnalytics /> },
  { path: "/dashboard-crm", component: <DashboardCrm /> },
  { path: "/dashboard", component: <DashboardEcommerce /> },
  { path: "/index", component: <DashboardEcommerce /> },
  { path: "/dashboard-crypto", component: <DashboardCrypto /> },
  { path: "/dashboard-projects", component: <DashboardProject /> },
  { path: "/dashboard-nft", component: <DashboardNFT /> },
  { path: "/dashboard-job", component: <DashboardJob /> },
  { path: "/dashboard-blog", component: <DashboardBlog /> },

  // apps
  { path: "/apps-calendar", component: <Calendar /> },
  { path: "/apps-calendar-month-grid", component: <MonthGrid /> },
  { path: "/apps-ecommerce-products", component: <EcommerceProducts /> },
  { path: "/apps-ecommerce-product-details/:id", component: <EcommerceProductDetail /> },
  { path: "/apps-ecommerce-add-product", component: <EcommerceAddProduct /> },
  { path: "/apps-ecommerce-drafts", component: <EcommerceDrafts /> },
  { path: "/apps-ecommerce-drafts/edit/:asin", component: <EditDraft /> },
  { path: "/publish/success", component: <PublishSuccess /> },
  { path: "/apps-ecommerce-orders", component: <EcommerceOrders /> },
  { path: "/apps-ecommerce-order-details/:id", component: <EcommerceOrderDetail /> },
  { path: "/apps-ecommerce-customers", component: <EcommerceCustomers /> },
  { path: "/apps-ecommerce-cart", component: <EcommerceCart /> },
  { path: "/apps-ecommerce-checkout", component: <EcommerceCheckout /> },
  { path: "/apps-ecommerce-sellers", component: <EcommerceSellers /> },
  { path: "/apps-ecommerce-seller-details", component: <EcommerceSellerDetail /> },
  { path: "/apps-file-manager", component: <FileManager /> },
  { path: "/apps-todo", component: <ToDoList /> },

  // //Chat
  { path: "/apps-chat", component: <Chat /> },

  // //EMail
  { path: "/apps-mailbox", component: <MailInbox /> },
  { path: "/apps-email-basic", component: <BasicAction /> },
  { path: "/apps-email-ecommerce", component: <EcommerceAction /> },

  // //Projects
  { path: "/apps-projects-list", component: <ProjectList /> },
  { path: "/apps-projects-overview", component: <ProjectOverview /> },
  { path: "/apps-projects-create", component: <CreateProject /> },

  // //Task
  { path: "/apps-tasks-kanban", component: <Kanbanboard /> },
  { path: "/apps-tasks-list-view", component: <TaskList /> },
  { path: "/apps-tasks-details", component: <TaskDetails /> },

  // //Api Key
  { path: "/apps-api-key", component: <APIKey /> },

  // //Invoices
  { path: "/apps-invoices-list", component: <InvoiceList /> },
  { path: "/apps-invoices-details", component: <InvoiceDetails /> },
  { path: "/apps-invoices-create", component: <InvoiceCreate /> },

  // //Supports Tickets
  { path: "/apps-tickets-list", component: <UserTickets /> },
  { path: "/apps-tickets-detail/:id", component: <TicketDetail /> },
  { path: "/apps-tickets-details", component: <TicketsDetails /> },

  // //transactions
  { path: "/apps-crypto-transactions", component: <Transactions /> },
  { path: "/apps-crypto-buy-sell", component: <BuySell /> },
  { path: "/apps-crypto-orders", component: <CryproOrder /> },
  { path: "/apps-crypto-wallet", component: <MyWallet /> },
  { path: "/apps-crypto-ico", component: <ICOList /> },
  { path: "/apps-crypto-kyc", component: <KYCVerification /> },

  // // NFT Marketplace
  { path: "/apps-nft-marketplace", component: <Marketplace /> },
  { path: "/apps-nft-collections", component: <Collections /> },
  { path: "/apps-nft-create", component: <CreateNFT /> },
  { path: "/apps-nft-creators", component: <Creators /> },
  { path: "/apps-nft-explore", component: <ExploreNow /> },
  { path: "/apps-nft-item-details", component: <ItemDetails /> },
  { path: "/apps-nft-auction", component: <LiveAuction /> },
  { path: "/apps-nft-ranking", component: <Ranking /> },
  { path: "/apps-nft-wallet", component: <WalletConnect /> },

  // //charts
  { path: "/charts-apex-line", component: <LineCharts /> },
  { path: "/charts-apex-area", component: <AreaCharts /> },
  { path: "/charts-apex-column", component: <ColumnCharts /> },
  { path: "/charts-apex-bar", component: <BarCharts /> },
  { path: "/charts-apex-mixed", component: <MixedCharts /> },
  { path: "/charts-apex-timeline", component: <TimelineCharts /> },
  { path: "/charts-apex-range-area", component: <RangeArea /> },
  { path: "/charts-apex-funnel", component: <FunnelChart /> },
  { path: "/charts-apex-candlestick", component: <CandlestickChart /> },
  { path: "/charts-apex-boxplot", component: <BoxplotCharts /> },
  { path: "/charts-apex-bubble", component: <BubbleChart /> },
  { path: "/charts-apex-scatter", component: <ScatterCharts /> },
  { path: "/charts-apex-heatmap", component: <HeatmapCharts /> },
  { path: "/charts-apex-treemap", component: <TreemapCharts /> },
  { path: "/charts-apex-pie", component: <PieCharts /> },
  { path: "/charts-apex-radialbar", component: <RadialbarCharts /> },
  { path: "/charts-apex-radar", component: <RadarCharts /> },
  { path: "/charts-apex-polar", component: <PolarCharts /> },
  { path: "/charts-apex-slope", component: <SlopeCharts /> },
  
  { path: "/charts-chartjs", component: <ChartsJs /> },
  { path: "/charts-echarts", component: <Echarts /> },


  // // Base Ui
  { path: "/ui-alerts", component: <UiAlerts /> },
  { path: "/ui-badges", component: <UiBadges /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdowns /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-tabs", component: <UiTabs /> },
  { path: "/ui-accordions", component: <UiAccordions /> },
  { path: "/ui-modals", component: <UiModals /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-progress", component: <UiProgress /> },
  { path: "/ui-notifications", component: <UiNotifications /> },
  { path: "/ui-media", component: <UiMediaobject /> },
  { path: "/ui-embed-video", component: <UiEmbedVideo /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-lists", component: <UiList /> },
  { path: "/ui-links", component: <UiLink /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-ribbons", component: <UiRibbons /> },
  { path: "/ui-utilities", component: <UiUtilities /> },

  // // Advance Ui
  { path: "/advance-ui-scrollbar", component: <UiScrollbar /> },
  { path: "/advance-ui-animation", component: <UiAnimation /> },
  { path: "/advance-ui-swiper", component: <UiSwiperSlider /> },
  { path: "/advance-ui-ratings", component: <UiRatings /> },
  { path: "/advance-ui-highlight", component: <UiHighlight /> },

  // // Widgets
  { path: "/widgets", component: <Widgets /> },

  // // Forms
  { path: "/forms-elements", component: <BasicElements /> },
  { path: "/forms-select", component: <FormSelect /> },
  { path: "/forms-checkboxes-radios", component: <CheckBoxAndRadio /> },
  { path: "/forms-pickers", component: <FormPickers /> },
  { path: "/forms-masks", component: <Masks /> },
  { path: "/forms-advanced", component: <FormAdvanced /> },
  { path: "/forms-range-sliders", component: <FormRangeSlider /> },
  { path: "/forms-validation", component: <FormValidation /> },
  { path: "/forms-wizard", component: <FormWizard /> },
  { path: "/forms-editors", component: <FormEditor /> },
  { path: "/forms-file-uploads", component: <FileUpload /> },
  { path: "/forms-layouts", component: <Formlayouts /> },
  { path: "/forms-select2", component: <Select2 /> },

  // //Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-react", component: <ReactTable /> },

  // //Icons
  { path: "/icons-remix", component: <RemixIcons /> },
  { path: "/icons-boxicons", component: <BoxIcons /> },
  { path: "/icons-materialdesign", component: <MaterialDesign /> },
  { path: "/icons-feather", component: <FeatherIcons /> },
  { path: "/icons-lineawesome", component: <LineAwesomeIcons /> },
  { path: "/icons-crypto", component: <CryptoIcons /> },

  // //Maps
  { path: "/maps-google", component: <GoogleMaps /> },

  // //Pages
  { path: "/pages-starter", component: <Starter /> },
  { path: "/pages-profile", component: <SimplePage /> },
  { path: "/pages-profile-settings", component: <ProfileSettings /> },
  { path: "/settings", component: <Settings /> },
  { path: "/settings/stores", component: <UserStoreManagement /> },
  { path: "/ebay-connect", component: <EbayConnect /> },
  { path: "/ebay-callback", component: <EbayCallback /> },
  { path: "/setup-wizard", component: <SetupWizard /> },
  { path: "/admin/dashboard", component: <AdminDashboard /> },
  { path: "/admin/users", component: <UserList /> },
  { path: "/admin/users/:userId", component: <UserDetail /> },
  { path: "/admin/audit-logs", component: <AuditLogs /> },
  { path: "/admin/credits", component: <CreditManagement /> },
  { path: "/admin/payments", component: <PaymentManagement /> },
  { path: "/admin/invoices", component: <InvoiceManagement /> },
  { path: "/admin/stores", component: <StoreManagement /> },
  { path: "/admin/ebay-accounts", component: <EbayAccountManagement /> },
  { path: "/admin/reports", component: <Reports /> },
  { path: "/admin/notifications", component: <Notifications /> },
  { path: "/admin/system-settings", component: <SystemSettings /> },
  { path: "/admin/email-settings", component: <EmailSettings /> },
  { path: "/admin/system-health", component: <SystemHealth /> },
  { path: "/admin/ops-health", component: <OpsHealth /> },
  { path: "/admin/scraper-monitoring", component: <ScraperMonitoring /> },
  { path: "/admin/subscription-health", component: <SubscriptionHealth /> },
  { path: "/admin/discount-codes", component: <DiscountCodes /> },
  { path: "/admin/tickets", component: <AdminTicketManagement /> },
  { path: "/admin/tickets/:id", component: <AdminTicketDetail /> },
  { path: "/pages-team", component: <Team /> },
  { path: "/pages-timeline", component: <Timeline /> },
  { path: "/pages-faqs", component: <Faqs /> },
  { path: "/pages-gallery", component: <Gallery /> },
  { path: "/subscription", component: <Subscription /> },
  { path: "/pages-sitemap", component: <SiteMap /> },
  { path: "/pages-search-results", component: <SearchResults /> },
  { path: "/pages-privacy-policy", component: <PrivacyPolicy /> },
  { path: "/pages-terms-condition", component: <TermsCondition /> },
  { path: "/pages-blog-list", component: <BlogListView /> },
  { path: "/pages-blog-grid", component: <BlogGridView /> },
  { path: "/pages-blog-overview", component: <PageBlogOverview /> },

  // //Job pages
  { path: "/apps-job-statistics", component: <Statistics /> },
  { path: "/apps-job-lists", component: <JobList /> },
  { path: "/apps-job-grid-lists", component: <JobGrid /> },
  { path: "/apps-job-details", component: <JobOverview /> },
  { path: "/apps-job-candidate-lists", component: <CandidateList /> },
  { path: "/apps-job-candidate-grid", component: <CandidateGrid /> },
  { path: "/apps-job-application", component: <Application /> },
  { path: "/apps-job-new", component: <NewJobs /> },
  { path: "/apps-job-companies-lists", component: <CompaniesList /> },
  { path: "/apps-job-categories", component: <JobCategories /> },



  //User Profile
  { path: "/profile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/register", component: <Register /> },
  { path: "/auth/google/callback", component: <GoogleCallback /> },

  // //AuthenticationInner pages
  { path: "/auth-signin-basic", component: <BasicSignIn /> },
  { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/auth-signup-basic", component: <BasicSignUp /> },
  { path: "/auth-signup-cover", component: <CoverSignUp /> },
  { path: "/auth-pass-reset-basic", component: <BasicPasswReset /> },
  { path: "/auth-pass-reset-cover", component: <CoverPasswReset /> },
  { path: "/auth-lockscreen-basic", component: <BasicLockScreen /> },
  { path: "/auth-lockscreen-cover", component: <CoverLockScreen /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-success-msg-basic", component: <BasicSuccessMsg /> },
  { path: "/auth-success-msg-cover", component: <CoverSuccessMsg /> },
  { path: "/auth-twostep-basic", component: <BasicTwosVerify /> },
  { path: "/auth-twostep-cover", component: <CoverTwosVerify /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },

  { path: "/", component: <CoderomLanding /> },
  { path: "/landing", component: <CoderomLanding /> },
  { path: "/faq", component: <FAQPage /> },
    { path: "/help", component: <HelpCenter /> },
  { path: "/help/getting-started", component: <HelpArticleGettingStarted /> },
  { path: "/help/ai-listing", component: <HelpArticleAiListing /> },
  { path: "/help/bulk-import", component: <HelpArticleBulkImport /> },
  { path: "/help/templates", component: <HelpArticleTemplates /> },
  { path: "/help/pricing", component: <HelpArticlePricing /> },
  { path: "/help/safe-repricing", component: <HelpArticleSafeRepricing /> },
  { path: "/help/stock", component: <HelpArticleStock /> },
  { path: "/help/amazon-filters", component: <HelpArticleAmazonFilters /> },
  { path: "/help/orders", component: <HelpArticleOrders /> },
  { path: "/help/safety-protection", component: <HelpArticleSafetyProtection /> },
  { path: "/help/auto-messages", component: <HelpArticleAutoMessages /> },
  { path: "/help/gmail-tracking", component: <HelpArticleGmailTracking /> },
  { path: "/help/ebay-multistore", component: <HelpArticleEbayMultistore /> },
  { path: "/help/reports", component: <HelpArticleReports /> },
  { path: "/help/account-billing", component: <HelpArticleAccountBilling /> },
  { path: "/help/migration", component: <HelpArticleMigration /> },
  { path: "/blog/:slug", component: <BlogPostDetail /> },
  { path: "/blog", component: <BlogPage /> },
  { path: "/community", component: <CommunityPage /> },
  { path: "/privacy", component: <CoderomPrivacyPolicy /> },
  { path: "/terms", component: <CoderomTermsOfService /> },
  { path: "/cookies", component: <CoderomCookiePolicy /> },
  { path: "/gdpr", component: <CoderomGDPRPolicy /> },
  { path: "/about", component: <AboutUs /> },
  { path: "/pages-pricing", component: <PricingPage /> },

  { path: "/auth-pass-change-basic", component: <BasicPasswCreate /> },
  { path: "/auth-pass-change-cover", component: <CoverPasswCreate /> },
  { path: "/auth-offline", component: <Offlinepage /> },

  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-coming-soon", component: <ComingSoon /> },

  // Tools (client-side calculators)
  { path: "/tools/ebay-fee-calculator", component: <EbayFeeCalculator /> },
  { path: "/tools/profit-calculator", component: <ProfitCalculator /> },
  { path: "/tools/title-optimizer", component: <TitleOptimizer /> },

  // Compare (competitor comparison pages)
  { path: "/compare/coderom-vs-autods", component: <CompareAutoDS /> },
  { path: "/compare/coderom-vs-easync", component: <CompareEasync /> },
  { path: "/compare/coderom-vs-yaballe", component: <CompareYaballe /> },

];

export { authProtectedRoutes, publicRoutes };